import axios from "axios"

import { devMode } from "./base"
const baseDomain = `https://gift${devMode ? "-dev" : ""}.mioto.vn`

export function getInfo() {
	return axios({
			withCredentials: true,
			method: "GET",
			url: `${baseDomain}/api/get-info`
	})
}